var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAiUnavailable(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 32H14V30H18V32ZM22.9141 21.0781L19.9961 23.9961L23.0703 27.0703L20.0508 30.0918L16.0078 26.0469L12.0508 30.0059L9.01562 26.9688L11.9883 23.9961L9.07031 21.0781L12.1016 18.0469L15.9922 21.9395L19.8828 18.0469L22.9141 21.0781ZM24 0C26.2092 0 28 1.79 28 4H30V1C30 1 30 0 31 0C32 0 32 1 32 1V4C32 4 32 6 30 6H28V10H30C32 10 32 12 32 12V15C32 15 32 16 31 16C30 16 30 15 30 15V12H28C28 14.21 26.2092 16 24 16H18V18H14V16H8C5.7908 16 4 14.21 4 12H2V15C2 15 2 16 1 16C0 16 0 15 0 15V12C0 12 0 10 2 10H4V6H2C0 6 0 4 0 4V1C0 1 0 0 1 0C2 0 2 1 2 1V4H4C4 1.79 5.7908 0 8 0H24ZM8 6V12H10V10H12V12H14V4H10L8 6ZM18 6H20V10H18V12H24V10H22V6H24V4H18V6ZM12 8H10V6H12V8Z",
    fill: "#CE0E0E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiUnavailable);
export default __webpack_public_path__ + "static/media/ai_unavailable.972613aebda52d0ef8a4ac35cfe896c5.svg";
export { ForwardRef as ReactComponent };